
import React from "react";


import Label from '../Label/Label'

// core components

import { Checkbox, CheckboxProps } from '@material-ui/core';

export interface CustomCheckboxProps extends CheckboxProps {
    labelText?: string;
    IsRequired?: boolean;
    isChecked?: boolean;
}
export default function CustomCheckBox(props: CustomCheckboxProps) {

    const {
        labelText,
        IsRequired,
        color,
        isChecked,
        checked,
        ...rest
    } = props;


    return (

        <>
            <Label labelText={labelText} IsRequired={IsRequired}></Label>
            <Checkbox
                color={color || "secondary"}
                checked={checked ?? isChecked ?? false}
                {...rest}
            />
        </>
    )
}


